import { ToastContainer, toast } from 'react-toastify';

export const ErrorNotification=(message)=>{
    // Handle different types of error messages
    let displayMessage = message

    // If message is an object with nested error structure
    if (typeof message === 'object' && message !== null) {
        // Handle API error response objects like {date: ["Appointment date cannot be in the past."]}
        if (typeof message === 'object' && !Array.isArray(message)) {
            const errorMessages = []

            // Extract error messages from nested structure
            Object.keys(message).forEach(key => {
                if (Array.isArray(message[key])) {
                    // If it's an array of error messages
                    message[key].forEach(errorMsg => {
                        errorMessages.push(`${key}: ${errorMsg}`)
                    })
                } else if (typeof message[key] === 'string') {
                    // If it's a direct string error
                    errorMessages.push(`${key}: ${message[key]}`)
                }
            })

            displayMessage = errorMessages.join(', ')
        } else if (Array.isArray(message)) {
            // If it's an array of error messages
            displayMessage = message.join(', ')
        } else {
            // Fallback for other object types
            displayMessage = JSON.stringify(message)
        }
    }

    // If it's already a string, use it as is
    if (typeof displayMessage !== 'string') {
        displayMessage = String(displayMessage)
    }

    toast(displayMessage, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"colored",
        type:"error"
        });

}


export const SuccessNotification=(message)=>{
    toast(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"colored",
        type:"success"
        });

}

